<template>
  <div>
    <table v-if="!loading" class="benchmark-table">
      <thead>
        <tr>
          <th>CIS Benchmark</th>
          <th>CIS-CAT Pro Assessor v4:</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="benchmark in benchmarks" :key="benchmark.id">
          <td class="benchmark-title">
            <a :href="benchmark.url">
              {{ benchmark.benchmarkTitle.value }} v{{ benchmark.benchmarkVersion.value }}</a
            >
          </td>
          <td class="catpro-supported"></td>
        </tr>
        <tr>
          <td>Total Benchmarks Available in CIS-CAT Assessor</td>
          <td>{{ benchmarks.length }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { useQuery } from '@vue/apollo-composable';
import { ItemQuery } from './CIS-Benchmark-CIS-CAT-Pro.graphql';

export default {
  name: 'CIS-Benchmark-CIS-CAT-Pro',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { result, loading, error } = useQuery(ItemQuery);

    return {
      result,
      loading,
      error
    };
  },
  computed: {
    benchmarks() {
      //todo; filter this object to get the Benchmark Version
      // objects with proV4.boolValue === true and map it to get the
      // fields (benchmarkTitle.value, technologyVersion.value) along with
      // the Benchmark's Url.
      //return this.fields?.data?.item?.children ?? [];

      if (this.loading || this.error) {
        return [];
      }

      const removeStrings = (value) => {
        ['CIS ', ' Benchmark'].forEach((str) => {
          value = value.replace(str, '');
        });

        return value.trim();
      };

      const output = (this.result?.item?.children || [])
        .filter((b) => b.benchmarkVersions.targetItems.some((v) => v.proV4.boolValue === true))
        .map((b) => {
          const benchmarkUrl = b.url;
          return b.benchmarkVersions.targetItems
            .filter((v) => v.proV4.boolValue === true)
            .map((v) => {
              return {
                ...v,
                // Remove extraneous strings from title
                benchmarkTitle: { value: removeStrings(v.benchmarkTitle.value) },
                url: benchmarkUrl
              };
            });
        })
        .flat()
        .sort((a, b) => {
          const nameA = a.benchmarkTitle.value;
          const nameB = b.benchmarkTitle.value;
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

      return output;
    }
  }
};
</script>

<style lang="scss" scoped>
.benchmark-table {
  display: grid;
  width: 100%;
  tr {
    display: grid;
    grid-template-columns: 5fr 3fr;
    @include tablet-up {
      grid-template-columns: 5fr 2fr;
    }
    &:first-child {
      background: $white;
      position: sticky;
      z-index: 10;
      top: 0;
    }
  }
  th,
  td {
    padding: 1rem 1.5rem;
    font-weight: normal;
    outline: 1px solid $divider;
    @include tablet-up {
      padding: 1rem 2rem;
    }
  }
  th:last-child {
    text-align: center;
  }
  td {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    &:first-child {
      justify-content: flex-start;
      text-align: left;
    }
  }
}
.catpro-supported {
  &:before {
    content: '';
    position: relative;
    top: 1rem;
    display: inline-block;
    width: 2.1rem;
    height: 2.1rem;
    left: -3rem;
    -webkit-mask: url(~@/assets/images/icon-checkmark.svg);
    mask: url(~@/assets/images/icon-checkmark.svg);
    background-color: $orange;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    top: auto;
    left: auto;
  }
}
</style>
